import styled from 'styled-components';
import { colors } from '../../style/colors';
import { max } from '../../lib/responsive';
import { H3, SubH } from '../../style/typography';

const PrevConfContainer = styled.div`
  width: 100%;
  background-color: ${colors.GRAY};
`;

const ConferenceSectionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 6.25rem;
  padding-bottom: 6rem;

  @media ${max.tabletLg} {
    flex-direction: column-reverse;
    margin-top: 0;
  }
`;

const PrevConfHeading = styled(H3)`
  color: ${colors.PINK};
  padding-top: 7.063rem;
  line-height: 2.313rem;
  margin: 0;

  @media ${max.tabletSm} {
    display: none;
  }
`;

const PrevConfHeadingMobile = styled(H3)`
  display: none;
  margin: 0;

  @media ${max.tabletSm} {
    display: block;
    color: ${colors.PINK};
    padding-top: 5rem;
    line-height: 2.5rem;
  }
`;

const ConferenceSection = styled.div`
  color: ${colors.WHITE};
  width: 50%;
  display: flex;
  flex-direction: column;
  height: 12.5rem;
  padding-top: 0.625rem;

  :hover {
    background-color: ${props => {
      switch (props.colorMode) {
        case 0:
          return `${colors.RED}`;
        case 1:
          return `${colors.TAN}`;
        case 2:
          return `${colors.YELLOW}`;
        case 3:
          return `${colors.PERIWINKLE}`;
        default:
          return `${colors.WHITE}`;
      }
    }};

    color: ${props => {
      switch (props.colorMode) {
        case 0:
          return `${colors.PINK}`;
        case 1:
          return `${colors.MINT}`;
        case 2:
          return `${colors.RED}`;
        case 3:
          return `${colors.BLUE}`;
        default:
          return `${colors.WHITE}`;
      }
    }};
  }

  @media ${max.tabletLg} {
    height: auto;

    :hover {
      background-color: transparent;
      color: ${colors.WHITE};
    }
  }
`;

const ConferenceHeading = styled.div`
  display: flex;

  @media ${max.tabletLg} {
    flex-direction: column;
  }
`;

const ConferenceYear = styled(SubH)`
  font-size: 1.25em;
  padding-top: 1.65rem;
`;

const ConferenceName = styled(H3)`
  font-size: 2.25em;
  color: inherit;
  width: 25%;
  margin-left: 1.25rem;
  letter-spacing: 0.085em;
  margin-bottom: 1rem;

  @media ${max.tabletLg} {
    display: none;
  }
`;

const MobileConferenceName = styled(H3)`
  display: none;
  
  @media ${max.tabletLg} {
    font-size: 2.25em;
    width: 50%;
    margin-top: 0;
    margin-bottom: 1.5rem;
    color: ${colors.WHITE};
    line-height: 2.313rem;
    display: block;
`;

const LearnMoreButton = styled.button`
  display: none;

  @media ${max.tabletLg} {
    display: inline;
    background-color: ${colors.RED};
    width: 14rem;
    height: 3.25rem;
    position: relative;
    border: none;

    :hover {
      cursor: pointer;
    }
  }
`;

const ButtonLabel = styled(SubH)`
  display: none;

  @media ${max.tabletLg} {
    display: inline;
    color: ${colors.WHITE};
    letter-spacing: 0.085em;
  }
`;

const LearnMoreCaption = styled(SubH)`
  display: block;
  line-height: 187.7%;
  letter-spacing: 0.085em;
  margin-left: 4.3rem;
  margin-top: 0;
  width: fit-content;

  color: ${props => {
    switch (props.inputColor) {
      case 0:
      case 3:
        return `${colors.WHITE}`;
      case 1:
      case 2:
        return `${colors.BLACK}`;
      default:
        return `${colors.WHITE}`;
    }
  }};

  @media ${max.tabletLg} {
    display: none;
  }
`;

const SiteLink = styled.a`
  text-decoration: none;
  width: fit-content;
`;

export {
  PrevConfContainer,
  PrevConfHeading,
  PrevConfHeadingMobile,
  ConferenceSectionContainer,
  ConferenceSection,
  ConferenceHeading,
  ConferenceYear,
  ConferenceName,
  MobileConferenceName,
  LearnMoreButton,
  ButtonLabel,
  LearnMoreCaption,
  SiteLink,
};
